(function matchesPolyfill () {

    if (!Element.prototype.matches) {

        Element.prototype.matches = Element.prototype['matchesSelector'] ||
                                    Element.prototype.webkitMatchesSelector ||
                                    Element.prototype['mozMatchesSelector'] ||
                                    Element.prototype['msMatchesSelector'];

    }
}());

(function closestPolyfill() {
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(css) {
            let node = this;
            while (node) {
                if (node.matches(css)) {
                    return node;
                }
                node = node.parentElement;
            }
            return null;
        };
    }
}());

(function removePolyfill() {
    var arr = [(window as any).Element, (window as any).CharacterData, (window as any).DocumentType];
    var args = [];

    arr.forEach(function (item) {
        if (item) {
            args.push(item.prototype);
        }
    });

    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('remove')) {
                return;
            }
            Object.defineProperty(item, 'remove', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function remove() {
                    this.parentNode.removeChild(this);
                }
            });
        });
    })(args);
})();

(function findPolyfill() {
    if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }
}());

(function entriesPolyfill() {
    if (!Object.entries) {
        Object.entries = function (obj) {
            if (obj === null || obj === undefined) {
                throw new Error('Cannot convert undefined or null to object');
            }

            let entries = [];
            for (let prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    entries.push([prop, obj[prop]]);
                }
            }
            return entries;
        };
    }
}());

(function valuesPolyfill() {
    if (!Object.values) {
        Object.values = function (obj) {
            if (obj === null || obj === undefined) {
                throw new Error('Cannot convert undefined or null to object');
            }

            let values = [];
            for (let prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    values.push(obj[prop]);
                }
            }
            return values;
        };
    }
}());

/** @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill */
(function () {
    // Internet Explorer >= 9 adds a CustomEvent object to the window, but with correct implementations, this is a function.
    if (typeof window['CustomEvent'] === 'function') {
        return;
    }

    interface CustomEventParams extends Event {
        detail: boolean;
    }

    function CustomEvent(type: string, params: Partial<CustomEventParams> = {}): Event {
        let {
            bubbles = false,
            cancelable = false,
            detail = null,
        } = params;

        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(type, bubbles, cancelable, detail);
        return evt;
    }

    CustomEvent.prototype = window['Event'].prototype;

    // tslint:disable-next-line
    window['CustomEvent'] = CustomEvent as any;
})();
